module.exports = __webpack_public_path__ + "static/media/PredictabillLogo-Clear.baf9b59b.svg";